document.addEventListener('DOMContentLoaded', () => {
  // すべての質問ボタンを取得
  const faqQuestions = document.querySelectorAll('.faq-question');

  faqQuestions.forEach(question => {
    question.addEventListener('click', () => {
      // クリックされたボタンの親要素（.faq-item）を取得
      const faqItem = question.parentElement;
      
      // .is-open クラスをつけ外し（トグル）する
      faqItem.classList.toggle('is-open');
    });
  });
});

document.addEventListener('click', function (e) {
  // クリックされた要素（またはその内側の要素）に .js-scroll-btn があるか判定
  const button = e.target.closest('.js-scroll-btn');
  if (!button) return;

  e.preventDefault(); // 通常のアンカー挙動を無効化
  
  const targetId = button.getAttribute('href');
  const targetElement = document.querySelector(targetId);
  
  if (targetElement) {
    const targetOffset = targetElement.getBoundingClientRect().top + window.pageYOffset;
    const headerOffset = 200; // ★固定ヘッダーの高さに合わせて数値を調整してください
    
    window.scrollTo({
      top: targetOffset - headerOffset,
      behavior: 'smooth' // スムーズにスクロール
    });
  } else {
    // 【デバッグ用】もし移動先のIDが見つからない場合は画面にアラートを出します
    alert('移動先のフォーム（' + targetId + '）がページ内に見つかりません。フォーム側のID名をご確認ください。');
  }
});